import debounce from 'lodash.debounce';
import { WebAuthn } from '../shared/Authentication';
import { SignInActions, SignInComponents } from '../sign_in';

document.addEventListener('DOMContentLoaded', () => {
  if (SignInComponents.webauthn()) {
    /*
      Some browsers don't support WebAuthn feature (e.g. IE). For such cases,
      we disable a form and display an explanation.
    */
    if (!WebAuthn.supported()) SignInActions.disableWebauthn();

    SignInComponents.webauthnForm()?.addEventListener(
      'submit',
      SignInActions.authenticateWithWebauthn
    );
  }

  document.getElementById('show-authentication-code-form')?.addEventListener(
    'click',
    SignInActions.replaceAuthenticationForm('webauthn', 'oneTimeCode')
  );

  document.getElementById('show-security-key-form')?.addEventListener(
    'click',
    SignInActions.replaceAuthenticationForm('oneTimeCode', 'webauthn')
  );

  if (SignInComponents.signInForm()) {
    if (SignInComponents.emailOnSignInForm().value) {
      SignInActions.checkNextStep(SignInActions.authenticateWithWebauthn)();
    }

    SignInComponents.emailOnSignInForm().addEventListener(
      'input',
      debounce(SignInActions.checkNextStep(SignInActions.authenticateWithWebauthn), 500)
    );
  }
});
